import { BybButtonVR } from "@Components/game/common";
import {
  useSessionResultsScenarioData,
  useSessionResultsStaticContext,
  useSessionResultsTabContext,
} from "@Context/game/activity/session-results-context";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";
import { getFeedbackSubtitle, getFeedbackTitle } from "@Helpers/feedback";
import useI18n from "@i18n";
import { Skeleton, Stack, Typography, useTheme } from "@mui/material";

const SessionResultsBackground = () => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const { currentTab } = useSessionResultsTabContext();

  if (currentTab > 0) {
    return null;
  }

  const { scenarioData, targetOutcome } = useSessionResultsScenarioData();
  const { nextChallenge, showNextChallengeCta, handleNextChallengeClick } = useSessionResultsStaticContext();

  const feedbackTitle = targetOutcome ? i18n(getFeedbackTitle(scenarioData?.cognitive_result_id || 0, targetOutcome, false)) : "";
  const feedbackSubtitle = targetOutcome ? i18n(getFeedbackSubtitle(scenarioData?.cognitive_result_id || 0, targetOutcome, false)) : "";

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      spacing={2}
      paddingTop={4}
      height="auto"
      paddingBottom={showNextChallengeCta ? theme.spacing(8) : theme.spacing(12)}
    >
      <Typography variant="text8xl700" color="white">
        {targetOutcome ? feedbackTitle : <Skeleton variant="text" width={300} height={64} />}
      </Typography>
      <Typography variant="text2xl400" color="white">
        {targetOutcome ? feedbackSubtitle : <Skeleton variant="text" width={500} height={32} />}
      </Typography>
      {showNextChallengeCta && (
        <Stack paddingTop={2}>
          <BybButtonVR onClick={handleNextChallengeClick} disabled={!nextChallenge} icon={faPlay} shape="pill">
            {i18n("session-results.next-challenge")}
          </BybButtonVR>
        </Stack>
      )}
    </Stack>
  );
};

export default SessionResultsBackground;
